import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import { editManufacturers } from '../../redux/actions/manufacturers';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/manufacturer';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    description: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const manufacturers = useSelector(state => state.manufacturers);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/manufacturers', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0]
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    dispatch(editManufacturers(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {manufacturers.editSuccess && (
        <AlertMsg type="success" msg="Fabricante atualizado com sucesso" />
      )}
      {manufacturers.errorContent &&
        !manufacturers.errorContent.message.includes('400') &&
        manufacturers.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do fabricante"
        />
      )}
      {manufacturers.errorContent &&
        manufacturers.errorContent.message.includes('400') &&
        manufacturers.editError && (
        <AlertMsg
          type="danger"
          msg="Um fabricante com o nome informado já está cadastrado"
        />
      )}
      {!manufacturers.editSuccess && !manufacturers.editError && (
        <AlertMsg type="info" msg="Área atualização de fabricantes" />
      )}
      <FormHeader title="Atualizar Fabricante" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.name}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.description}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/manufacturers" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
